/**
 * Resolves the languageLookupId to send when creating a language record, whether
 * adding from the lookup dropdown or "Create New" while editing an existing language.
 *
 * A language added from the lookup list carries its own lookup id, which is
 * used as-is. The default language has no lookup id (it is the tenant's seeded
 * base language), so one is derived from the language lookup list by matching
 * the language's original code. This lets "Create New" work from the default
 * instead of sending an empty/0 id that the API rejects.
 *
 * Codes are unique in the lookup list, so a match resolves to exactly one
 * entry. Returns undefined when nothing matches, so the caller fails cleanly
 * rather than sending a wrong id.
 *
 * @param optionTranslation the (possibly edited) working record
 * @param optionTranslationToEdit the original record being edited
 * @param languages the language lookup list ({ languageLookupId, googleLanguageCode })
 */
export function resolveLanguageLookupId (optionTranslation, optionTranslationToEdit, languages) {
	// On an edit record the lookup id is nested under `language`; on an add it
	// sits at the top level. A 0 or null id (the default) counts as absent.
	const existing = optionTranslation?.languageLookupId ?? optionTranslation?.language?.languageLookupId
	if (existing) return existing
	const originalCode = optionTranslationToEdit?.languageCode ?? optionTranslationToEdit?.language?.googleLanguageCode
	return (languages ?? []).find(lang => lang.googleLanguageCode?.toLowerCase() === originalCode?.toLowerCase())?.languageLookupId
}
